const INITIAL_STATE = {
    fontesPagamento: [],
    fontePagamento: {},
    cadastro: {},
    edicao: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'FONTE_EDICAO':
            return { ...state, edicao: !state.edicao }

        case 'FONTE_FETCH':
            return { ...state, fontesPagamento: action.payload }

        case 'FONTE_GET':
            return { ...state, fontePagamento: action.payload }

        case 'FONTE_INPUT_CHANGE':
            const cadastroCopy = { ...state.cadastro }
            cadastroCopy[action.campo] = action.payload
            
            return { ...state, cadastro: cadastroCopy }

        default:
            return state
    }
}